import { appConfigStore } from 'Models/AppConfigStore';
import { store } from 'Models/Store';

/**
 * Bulk booking is booking: staff without BookOnBehalfOfCustomer are refused it by the server, so the
 * Bulk book button is not offered to them rather than leading to the access-denied page.
 */
export function canAccessBulkBookings(): boolean {
	return (store.isStaff || store.isInvoicedUser) && store.mayMakeBookings && appConfigStore.bulkBookingsEnabled;
}
